module.exports = __webpack_public_path__ + "static/media/maf-29.4cf7e03f.png";